// extracted by mini-css-extract-plugin
export default {"radio":"Radio_radio__0Mfds","input":"Radio_input__kodpZ","inner":"Radio_inner__PDVOz","tick":"Radio_tick__zdeCm","text":"Radio_text__q1UkF"};